<template>
  <v-card color="background" height="100%">
    <v-row align="center" justify="center" style="margin-top: -50px; margin-bottom: 10px" no-gutters>
      <v-col align="center">
        <img src="@/assets/logo-paoli.png" width="180px" alt="" aria-hidden="true" />
      </v-col>
      <v-col align="center">
        <img src="@/assets/logo-bej.png" width="200px" />
      </v-col>
      <v-col align="center">
        <img src="@/assets/logo-inocencio-paula.png" width="300px" alt="" aria-hidden="true" />
      </v-col>
    </v-row>

    <v-app-bar app dark color="primary" clipped-left style="position: relative" class="hidden-md-and-down">
      <!-- <v-app-bar-nav-icon @click="drawer = !drawer" ></v-app-bar-nav-icon> -->

      <v-spacer class="d-none d-md-flex"></v-spacer>

      <div class="d-flex flex-wrap">
        <v-btn v-for="(item, index) in sidebarMenu" :key="index" text :to="item.route">
          {{ item.name }}
        </v-btn>

        <!-- About Process Dropdown Menu -->
        <v-menu min-width="200" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" class="ml-2" aria-label="Botão menu Sobre o Processo">
              Sobre o Processo
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list class="dropdown-menu-list">
            <v-list-item link :to="child.route" v-for="(child, index) in dropDownAboutProcess" :key="index"
              class="submenu-item">
              <v-list-item-content>
                <v-list-item-title class="submenu-text text-white-on-hover">{{
                  child.name
                  }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- Creditor Field Dropdown Menu -->
        <v-menu min-width="200" offset-y v-if="user">
          <template v-slot:activator="{ on, attrs }">
            <v-tooltip bottom :disabled="!hasMenuAlert">
              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                <span v-bind="tooltipAttrs" v-on="tooltipOn">
                  <v-badge :value="hasMenuAlert" color="warning" dot overlap>
                    <v-btn text v-bind="attrs" v-on="on" class="ml-2" aria-label="Botão menu Area do Credor">
                      {{ user.profile == 1 ? 'Área do Credor' : 'Área do Procurador' }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </v-badge>
                </span>
              </template>
              <span>{{ menuAlertText }}</span>
            </v-tooltip>
          </template>
          <v-list class="dropdown-menu-list">
            <v-list-item link :to="child.route" v-for="(child, index) in filteredDropDownCreditorArea" :key="index"
              class="submenu-item">
              <v-list-item-content>
                <v-list-item-title class="submenu-text text-white-on-hover">
                  {{ child.name }}
                  <v-icon v-if="isCertificateRoute(child.route) && hasPendingCertificateDocs"
                    small color="warning" class="ml-2">mdi-alert</v-icon>
                  <v-icon v-if="child.route === '/revisao-credito' && pendingDebtorRequests > 0"
                    small color="warning" class="ml-2">mdi-alert</v-icon>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu v-if="user" min-width="200" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              <v-icon class="mr-2">mdi-account</v-icon>
              {{ 'Olá, ' + normalizeName(user.name) }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item link @click.native="logout">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Sair</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn v-else text @click="dialogAccess = true" aria-label="Botão menu de Cadastro ou Login">
          <v-icon class="mr-2">mdi-account</v-icon>
          Cadastre-se / Login
        </v-btn>
      </div>

      <v-spacer class="d-none d-md-flex"></v-spacer>
    </v-app-bar>

    <!-- MENU MOBILE -->

    <div class="px-4 hidden-lg-and-up">
      <v-col class="" cols="12" justify="space-between" align="start">
        <v-btn icon color="black" @click="toogleMenuApp">
          <v-icon size="40">mdi-menu</v-icon>
          <!-- <span class="font-weight-bold ml-4">MENU</span> -->
        </v-btn>
      </v-col>
    </div>

    <v-row class="hidden-lg-and-up" v-if="menuApp">
      <v-col cols="12" justify="space-between" align="start">
        <v-col cols="12">
          <div class="py-2" v-for="(item, index) in sidebarMenu" :key="index">
            <template v-if="!item.children || item.children.length === 0">
              <v-btn @click="toogleMenuApp" text :to="item.route" class="menu-item">
                {{ item.name }}
              </v-btn>
            </template>
          </div>
        </v-col>

        <v-col cols="12" class="py-2">
          <v-btn text color="#2c4093" class="menu-buttons" style="margin-left: 10px" @click="toggleMobileAboutProcess">
            <span>
              SOBRE O PROCESSO
              <span>
                <v-icon right>{{ mobileAboutProcessOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </span>
            </span>
          </v-btn>

          <v-list v-if="mobileAboutProcessOpen" class="mobile-submenu-list hidden-lg-and-up">
            <v-list-item v-for="(item, index) in dropDownAboutProcess" :key="index" :to="item.route" link
              class="submenu-item" @click="closeMobileMenu">
              <v-list-item-content>
                <v-list-item-title class="submenu-text text-white-on-hover">
                  {{ item.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>

        <v-col v-if="user" cols="12" class="py-2">
          <v-tooltip bottom :disabled="!hasMenuAlert">
            <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
              <span v-bind="tooltipAttrs" v-on="tooltipOn">
                <v-badge :value="hasMenuAlert" color="warning" dot overlap>
                  <v-btn text color="#2c4093" class="ml-2 menu-buttons" @click="toggleMobileCreditorArea">
                    <span>
                      {{ user.profile == 1 ? 'AREA DO CREDOR' : 'AREA DO PROCURADOR' }}
                      <span>
                        <v-icon right>{{ mobileCreditorAreaOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </span>
                    </span>
                  </v-btn>
                </v-badge>
              </span>
            </template>
            <span>{{ menuAlertText }}</span>
          </v-tooltip>

          <v-list v-if="mobileCreditorAreaOpen" class="mobile-submenu-list hidden-lg-and-up">
            <v-list-item v-for="(item, index) in filteredDropDownCreditorArea" :key="index" :to="item.route" link
              class="submenu-item" @click="closeMobileMenu">
              <v-list-item-content>
                <v-list-item-title class="submenu-text text-white-on-hover">
                  {{ item.name }}
                  <v-icon v-if="isCertificateRoute(item.route) && hasPendingCertificateDocs"
                    small color="warning" class="ml-2">mdi-alert</v-icon>
                  <v-icon v-if="item.route === '/revisao-credito' && pendingDebtorRequests > 0"
                    small color="warning" class="ml-2">mdi-alert</v-icon>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>

        <v-menu v-if="user" min-width="200" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              <v-icon class="mr-2">mdi-account</v-icon>
              {{ 'Olá, ' + normalizeName(user.name) }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item link @click.native="logout">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Sair</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn v-else text @click="dialogAccess = true">
          <v-icon class="mr-2">mdi-account</v-icon>
          Cadastre-se / Login
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog persistent v-model="dialogRegister" :width="600">
      <register-component></register-component>
    </v-dialog>

    <v-dialog v-model="dialogForgotPassword" :width="600">
      <forgot-password-component></forgot-password-component>
    </v-dialog>

    <v-dialog v-model="dialogAccess" :width="600">
      <access-component></access-component>
    </v-dialog>

    <progress-bar></progress-bar>

    <!-- <v-row v-if="user">
      <v-col>
        <v-alert prominent type="#F44336">
          <v-row align="center">
            <v-col class="grow">
              <span class="text-info-alert"
                ><b>{{ normalizeName(user.name) }}</b
                >, verifique agora sua situação na lista de credores.</span
              >
            </v-col>
            <v-col class="shrink">
              <v-btn outlined to="/habilitacoes-divergencias">Clique Aqui</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row> -->

    <router-view></router-view>

    <v-footer padless class="footer-copyright py-5 mt-10 px-12" aria-hidden="true" tabindex="-1"
      aria-label="Informações sobre o rodapé da página">
      <v-row justify="center" align="center">
        <v-spacer></v-spacer>
        <v-col align="center">
          <span color="white">
            © {{ new Date().getFullYear() }} Recuperação Judicial 123 Milhas | Todos direitos
            reservados
          </span>
        </v-col>
        <v-col align="right">
          <a target="_blank" href="https://mazzitech.com.br" aria-hidden="true" tabindex="-1" alt="">
            <div>
              <span>Powered by</span>
            </div>
            <img src="@/assets/logo-mazzitech.svg" aria-hidden="true" tabindex="-1" loading="lazy" alt=""
              class="img-fluid image-footer" style="width: 150px" />
          </a>
        </v-col>
      </v-row>
    </v-footer>

    <!-- Modal para Termos de Uso -->
    <v-dialog v-model="termsModalVisible" max-width="800px" persistent>
        <v-card class="pa-3">
          <h1 class="pa-2 custom-modal-title font-weight-bold">
            NOVOS <span class="underline primary--text">TERMOS DE USO</span>
          </h1>
          <v-card-text class="mt-1 ml-0 pl-2">
            Novo Termo de Uso foi lançado, você pode conferi-lo abaixo. Para continuar
            navegando no site, você precisa aceitar o termo vigente.
            <v-row class="pt-5">
              <v-col cols="12">
                <v-btn
                  type="button"
                  elevation="0"
                  color="primary"
                  outlined
                  @click="openPrivacyFile('terms')"
                >
                  Visualizar Termo
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-0 ma-0">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" sm="5" class="pl-2 ml-0 pr-1">
                <v-btn color="primary" @click="acceptTerms('terms')" :disabled="loadingTerms">
                    <v-progress-circular
                      v-if="loadingTerms"
                      indeterminate
                      color="white"
                      size="20"
                      class="mr-2"
                    />
                    Aceitar Termos
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
    </v-dialog>
  
    <!-- Modal para Política de Privacidade -->
    <v-dialog v-model="privacyModalVisible" max-width="800px" persistent>
        <v-card class="pa-3">
          <h1 class="pa-2 custom-modal-title font-weight-bold">
            NOVA POLÍTICA DE <span class="underline primary--text">PRIVACIDADE</span>
          </h1>
          <v-card-text class="mt-1 ml-0 pl-2">
            Uma nova Política de Privacidade foi lançada, você pode conferi-la abaixo. Para continuar
            navegando no site, você precisa aceitar a política vigente.
            <v-row class="pt-5">
              <v-col cols="12">
                <v-btn
                  type="button"
                  elevation="0"
                  color="primary"
                  outlined
                  @click="openPrivacyFile('privacy')"
                >
                  Visualizar Política
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-0 ma-0">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" sm="5" class="pl-2 ml-0 pr-1">
                <v-btn color="primary" @click="acceptTerms('privacy')" :disabled="loadingPrivacy">
                    <v-progress-circular
                      v-if="loadingPrivacy"
                      indeterminate
                      color="white"
                      size="20"
                      class="mr-2"
                    />
                    Aceitar Política
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
    </v-dialog>
  
    <!-- Modal de Resumo -->
    <v-dialog v-model="summaryModalVisible" max-width="600px" persistent>
        <v-card class="pa-3">
          <h1 class="pa-2 custom-modal-title font-weight-bold">
            RESUMO DOS <span class="underline primary--text">TERMOS ACEITOS</span>
          </h1>
          <v-card-text class="mt-1 ml-0 pl-2">
            Você aceitou os seguintes termos:
            <ul v-if="acceptedTerms.length > 0">
              <li v-for="(term, index) in acceptedTerms" :key="index">
                {{ term.type === 'terms' ? 'Termos de Uso' : 'Política de Privacidade' }}
                (Versão: {{ term.version }}, Data: {{ formatDate(term.acceptedAt) }})
              </li>
            </ul>
            <p v-else>Nenhum termo foi aceito ainda!</p>
          </v-card-text>
          <v-card-actions class="pa-0 ma-0">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" sm="5" class="pl-2 ml-0 pr-1">
                <v-btn color="primary" @click="closeSummary">OK</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import { eventHub } from '@/main'

import router from '../router'
import axios from 'axios'

var parse = require('json-parse-safe')

import ProgressBar from '@/components/layout/ProgressBar.vue'
import Register from '@/views/user/Register.vue'
import Access from '@/views/user/Access.vue'
import ForgotPassword from '@/views/user/ForgotPassword.vue'

import dropDownCreditorArea from '@/common/data/creditor-area.data'
import dropDownAboutProcess from '@/common/data/about-process.data'

import sidebarMenu from '@/common/data/sidebar-menu.data'

export default {
  name: 'PublicLayout',

  components: {
    'progress-bar': ProgressBar,
    'register-component': Register,
    'access-component': Access,
    'forgot-password-component': ForgotPassword
  },

  data() {
    return {
      user: null,
      logoUrl: null,
      menuGroups: [],
      menuApp: false,
      mobileAboutProcessOpen: false,
      mobileCreditorAreaOpen: false,
      dataset: {
        loading: false,
      },
      drawer: false,
      dialogRegister: false,
      dialogAccess: false,
      dialogForgotPassword: false,
      searchTerm: null,
      displaySettingsMenu: false,
      sidebarMenu: sidebarMenu,
      dropDownCreditorArea: dropDownCreditorArea,
      dropDownAboutProcess: dropDownAboutProcess,
      showModal: false,
      summaryModalVisible: false,
      //activeHomeComponent: null,
      termsModalVisible: false,
      privacyModalVisible: false,
      termsAccepted: false,
      privacyAccepted: false,
      acceptedTerms: [],
      terms: null,
      privacy: null,
      loadingPrivacy: false,
      loadingTerms: false,
      hasPendingCertificateDocs: false,
      // Pedidos da Recuperanda aguardando a resposta do credor (Revisão de Crédito, Fase 2).
      pendingDebtorRequests: 0,
    }
  },

  watch: {
    user: {
      immediate: true,
      handler(value) {
        if (value && value.profile) {
          this.loadPendingCertificateDocs()
          this.loadPendingDebtorRequests()
        } else {
          this.hasPendingCertificateDocs = false
          this.pendingDebtorRequests = 0
        }
      }
    }
  },

  computed: {
    hasMenuAlert() {
      return this.hasPendingCertificateDocs || this.pendingDebtorRequests > 0
    },
    menuAlertText() {
      const texts = []
      if (this.pendingDebtorRequests > 0) texts.push(this.pendingDebtorRequests === 1 ? 'Há um pedido da Recuperanda aguardando resposta' : `Há ${this.pendingDebtorRequests} pedidos da Recuperanda aguardando resposta`)
      if (this.hasPendingCertificateDocs) texts.push('Existe uma solicitação de novos documentos')
      return texts.join(' · ')
    },
    filteredDropDownCreditorArea() {
      if (!this.user || !this.user.profile) return [];

      return dropDownCreditorArea.filter((item) => item.profiles.some((x) => x == this.user.profile) && (!item.module || this.$modules.isVisible(item.module)))
    },

    routeName() {
      return this.$route.name
    },

  },

  mounted() {
    this.monitorStorage()

    window.addEventListener('localStorageUpdated', (event) => {
      this.updateUser()
    })

    window.addEventListener('storage', (event) => {
      this.updateUser()
    })

    this.loadPolicies();
    this.checkAcceptedTerms();
  },

  beforeDestroy() {
    window.removeEventListener('localStorageUpdated', this.updateUser)
    window.removeEventListener('storage', this.updateUser)
  },

  created() {

    this.user = parse(localStorage.getItem('user')).value

    eventHub.$on('DIALOG-REGISTER', (value) => {
      this.dialogRegister = value
    })

    eventHub.$on('DIALOG-FORGOT-PASSWORD', (value) => {
      this.dialogForgotPassword = value
    })

    eventHub.$on('DIALOG-ACCESS', (value) => {
      this.dialogAccess = value
    })

    this.$ga.enable()

    eventHub.$on('logout', () => {
      this.logout()
    })

    eventHub.$on('CERTIFICATE-PENDING-DOCS-REFRESH', () => {
      this.loadPendingCertificateDocs()
    })

    eventHub.$on('DEBTOR-REQUESTS-REFRESH', () => {
      this.loadPendingDebtorRequests()
    })

    this.setActionButtons()
  },

  destroyed() {
    eventHub.$off('THEME_UPDATED')
  },

  methods: {
    setActionButtons() {
      // Grupo
    },

    updateUser() {
      this.user = parse(localStorage.getItem('user')).value
      // this.setActiveHomeComponent()
    },

    async loadPendingDebtorRequests() {
      const endpoint = this.user && this.user.profile === 1
        ? '/api/user-objection-events/creditor-answer/pending'
        : this.user && this.user.profile === 4
          ? '/api/lawyer-user-objection-events/creditor-answer/pending'
          : null
      if (!endpoint) {
        this.pendingDebtorRequests = 0
        return
      }
      try {
        const result = await axios.get(endpoint)
        this.pendingDebtorRequests = Number((result.data && result.data.content && result.data.content.count) || 0)
      } catch (error) {
        this.pendingDebtorRequests = 0
      }
    },

    isCertificateRoute(route) {
      return route === '/certidao-credito' || route === '/certidao-credito-procurador'
    },

    async loadPendingCertificateDocs() {
      if (!this.user || !this.user.profile) {
        this.hasPendingCertificateDocs = false
        return
      }

      const endpoint = this.user.profile === 1
        ? '/api/users-creditors/credit-certificate-requests/user'
        : this.user.profile === 4
          ? '/api/users-creditors/credit-certificate-requests/lawyer'
          : null

      if (!endpoint) {
        this.hasPendingCertificateDocs = false
        return
      }

      try {
        const result = await axios.get(endpoint)
        const content = result.data && result.data.content
        const records = (content && content.data) || content || []

        this.hasPendingCertificateDocs = records.some(record => {
          if (!record) return false
          if (Number(record.status) === 4) return true
          const reqDocs = record.requested_documents
          if (!reqDocs || !Array.isArray(reqDocs.files)) return false
          return reqDocs.files.some(f => Number(f.status) === 0)
        })
      } catch (error) {
        this.hasPendingCertificateDocs = false
      }
    },

    toogleMenuApp() {
      this.menuApp = !this.menuApp

      if (!this.menuApp) {
        this.mobileAboutProcessOpen = false
        this.mobileCreditorAreaOpen = false
      }
    },

    toggleMobileAboutProcess() {
      this.mobileAboutProcessOpen = !this.mobileAboutProcessOpen
      this.mobileCreditorAreaOpen = false
    },

    toggleMobileCreditorArea() {
      this.mobileCreditorAreaOpen = !this.mobileCreditorAreaOpen
      this.mobileAboutProcessOpen = false
    },

    closeMobileMenu() {
      this.menuApp = false
      this.mobileAboutProcessOpen = false
      this.mobileCreditorAreaOpen = false
    },

    menuActionClick(event) {
      event.preventDefault()
    },

    monitorStorage() {
      const originalSetItem = localStorage.setItem

      localStorage.setItem = (key, value) => {
        const event = new Event('localStorageUpdated')
        event.key = key
        event.newValue = value
        window.dispatchEvent(event)
        originalSetItem.apply(localStorage, [key, value])
      }
    },

    normalizeName(name) {
        if (!name || typeof name !== 'string') return '';
        const splitName = name.split(' ')
        return splitName.length > 1 ? splitName[0] : name
    },

    async logout() {
      // if (await this.$root.$confirm(true, "user.logout")) {
      //     userApi.clearcurrentUser;
      //     this.$router.push({ name: "Login" });
      // }

      localStorage.clear()

      this.user = null
      await this.$nextTick()

      //router.go('/home')
      this.$router.push('/home')
    },


    async loadPolicies() {
        const token = localStorage.getItem('token');
        
        if (!token || !this.user || !this.user.profile) return

        if (![1, 4].includes(this.user.profile)) {
            this.$dialog.notify.error('Perfil de usuário inválido', {
                position: 'top-right',
                timeout: 3000
            })
            return
        }

        this.loading = true;

        try {
            
            const profileType = this.user.profile === 1 ? 'users' : 'lawyers'
            
            const response = await axios.get(`/api/${profileType}/policies`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const { active, previous } = response.data.content;
            this.dataset.activePolicy = active;
            this.dataset.previousPolicies = previous;
            
        } catch (error) {
            this.$dialog.notify.error('Erro ao carregar políticas', {
                position: 'top-right',
                timeout: 3000
            });
            
        } finally {
            this.loading = false;
        }
    },


    async checkAcceptedTerms() {
        const token = localStorage.getItem('token');
        
        if (!token || !this.user || !this.user.profile) return

        if (![1, 4].includes(this.user.profile)) {
            this.$dialog.notify.error('Perfil de usuário inválido', {
                position: 'top-right',
                timeout: 3000
            })
            return
        }
        
        try {
            const profileType = this.user.profile === 1 ? '/api/users/terms/check-accepted' : '/api/lawyers/policies/check-accepted'
            const response = await axios.get(profileType, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const { termsAccepted, privacyAccepted, terms, privacy } = response.data.content;
            this.termsAccepted = termsAccepted;
            this.privacyAccepted = privacyAccepted;
            this.terms = terms;
            this.privacy = privacy;
            this.showModals();
            
        } catch (error) {
            this.$dialog.notify.error('Erro ao verificar termos', {
                position: 'top-right',
                timeout: 3000
            });
        }
    },

    async acceptTerms(type) {
        const token = localStorage.getItem('token');
        
        if (!token) {
            eventHub.$emit('DIALOG-ACCESS', true);
            return;
        }

        if (type === 'terms') this.loadingTerms = true;
        if (type === 'privacy') this.loadingPrivacy = true;

        await this.$nextTick();

        try {
            const profileType = this.user.profile === 1 ? 'users' : 'lawyers'
            const response = await axios.post(
                `/api/${profileType}/policies/accept`,
                { type },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            const { termId } = response.data.content;
            const acceptedAt = new Date().toISOString();

            if (type === 'terms') {
                this.termsAccepted = true;
                this.acceptedTerms.push({ type: 'terms', version: this.terms.version, acceptedAt });
                this.termsModalVisible = false;
                
                if (!this.privacyAccepted) {
                    this.privacyModalVisible = true;
                } else {
                    this.summaryModalVisible = true;
                }
            } else if (type === 'privacy') {
                this.privacyAccepted = true;
                this.acceptedTerms.push({ type: 'privacy', version: this.privacy.version, acceptedAt });
                this.privacyModalVisible = false;
                
                if (!this.termsAccepted) {
                    this.termsModalVisible = true;
                } else {
                    this.summaryModalVisible = true;
                }
            }
        } catch (error) {
            this.$dialog.notify.error(`Erro ao aceitar ${type}`, {
                position: 'top-right',
                timeout: 3000
            });
        }finally {
          if (type === 'terms') this.loadingTerms = false;
          if (type === 'privacy') this.loadingPrivacy = false;
        }
    },

    async openPrivacyFile(type) {
      const token = localStorage.getItem('token');
      
      if (!token || !this.user || !this.user.profile) {
          eventHub.$emit('DIALOG-ACCESS', true);
          return;
      }

      if (![1, 4].includes(this.user.profile)) {
          this.$dialog.notify.error('Perfil de usuário inválido', {
              position: 'top-right',
              timeout: 3000
          });
          return;
      }

      const doc = type === 'terms' ? this.terms : this.privacy;
      
      if (!doc) {
          this.$dialog.notify.error(`${type} não carregado`, {
              position: 'top-right',
              timeout: 3000
          });
          return;
      }

      const userTypeName = this.user.profile === 1 ? 'credor' : 'procurador';
      const documentName = type === 'terms' ? 'termos-de-uso' : 'politica-de-privacidade';

      try {
          const friendlyFileName = `${documentName}-${userTypeName}-v${doc.version}.pdf`;
          const friendlyUrl = `${axios.defaults.baseURL}/arquivo/${friendlyFileName}`;

          window.open(friendlyUrl, '_blank');
      } catch (error) {
          console.error(`Erro ao abrir ${type}:`, error);
          this.$dialog.notify.error(`Erro ao abrir ${type}`, {
              position: 'top-right',
              timeout: 3000
          });
      }
    },

    showModals() {

        if (!this.termsAccepted) {
            this.termsModalVisible = true;
        } else if (!this.privacyAccepted) {
            this.privacyModalVisible = true;
        }
    },

    closeSummary() {
        this.summaryModalVisible = false;
        this.acceptedTerms = [];
    },

    formatDate(date) {
        return new Date(date).toLocaleString('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'short'
        });
    },
    

  }
}
</script>

<style scoped lang="scss">
.title {
  color: var(--v-primary-base);
  text-decoration: none;
}

.menu-button-container {
  background-color: var(--v-secondary-base) !important;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 80px;
  text-align: center;
}

.menu-button {
  margin: auto;
  bottom: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}

.logged-user {
  text-align: left;
  margin-right: 10px;
  font-size: 13px;
  font-weight: 400;
  flex-direction: column;

  &-name {
    display: block;
  }

  &-email {
    display: block;
  }
}

.menu-subheader {
  padding-left: 16px;
  color: var(--v-primary-base);
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.001px;
}

.menu-title {
  padding-left: 16px;
  color: var(--v-important-base);
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
}

.footer-copyright {
  background-color: var(--v-primary-base) !important;

  a {
    text-decoration: none;
  }

  span {
    color: white !important;
    font-weight: 500;
  }
}

.dropdown-menu-list {
  //background-color: var(--v-primary-base) !important;
  padding: 0px;
  color: var(--v-important-base) !important;
  font-size: 13px !important;
  font-style: normal !important;
  font-weight: 400 !important;
}

.mobile-submenu-list {
  width: calc(100% - 24px);
  max-width: 320px;
  margin: 8px 0 0 12px;
  padding: 0;
  overflow: hidden;
  border-radius: 8px;
}

.submenu-item {
  color: rgb(255, 255, 255) !important;
  background-color: #2b3985 !important;
  padding-left: 16px;
  border-bottom: 1px solid #009986;
  font-family: 'Lucida Sans' !important;
  font-size: 12px !important;
  font-style: normal !important;
  line-height: 10px !important;
  transition: color 0.3s;
}

.submenu-text {
  font-size: 14px !important;
  font-weight: 500;
}

.menu-buttons {
  color: white !important;
  background-color: #2b4093 !important;
  border-bottom: 1px solid #009986;
  font-family: 'Raleway', sans-serif;
  font-size: 12px;
  font-style: normal;
  transition: color 0.3s;
  border-radius: 10px;
}

.menu-buttons:hover {
  color: rgb(14, 13, 13) !important; //var(--v-secondary-base) !important;
  background-color: white !important;
}

.submenu-item:hover {
  color: var(--v-secondary-base) !important;
}

.text-white-on-hover:hover {
  color: var(--v-secondary-base) !important;
}

.text-white-on-hover {
  color: white !important;
}

.text-info-alert {
  padding-left: 16px;
  color: var(--v-light-base);
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  text-transform: uppercase;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.001px;
}
</style>
